import { render, staticRenderFns } from "./d2-container-full-bs.vue?vue&type=template&id=8b5da740&"
import script from "./d2-container-full-bs.vue?vue&type=script&lang=js&"
export * from "./d2-container-full-bs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b5da740')) {
      api.createRecord('8b5da740', component.options)
    } else {
      api.reload('8b5da740', component.options)
    }
    module.hot.accept("./d2-container-full-bs.vue?vue&type=template&id=8b5da740&", function () {
      api.rerender('8b5da740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-container/components/d2-container-full-bs.vue"
export default component.exports